<template>
  <sonicu-button
    :bg-color="speedUp ? 'bg-green-600' : 'bg-pink-600'"
    @click="changeSpeed"
  >
    <span v-if="ajaxPollingData">
      <loading></loading>
    </span>
    <span v-else>
      <span v-if="speedUp">
        Speed Up
      </span>
      <span v-else>
        Speed Down
      </span>
    </span>
  </sonicu-button>
</template>

<script>
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import Loading from "@/components/elements/loading";
import {get} from "axios";
export default {
  name: "ProbeCalibrationReadFrequencyChange",
  components: {Loading, SonicuButton},
  props:{
    companyId:{
      type: String,
      required: true
    },
    zoneId:{
      type: String,
      required: true
    },
    speedUp:{
      type: Boolean,
      required: true
    },
  },
  data(){
    return {
      ajaxPollingData: false,
    };
  },
  computed: {
    href(){
      return '/api-internal/' + this.companyId + '/probe-calibration/read-frequency/' + this.zoneId + '/' + this.speed;
    },
    speed(){
      if(this.speedUp){
        return 5;
      } else {
        return 300;
      }
    }
  },
  methods: {
    changeSpeed(){
      this.ajaxPollingData = true;
      get(this.href)
        .then((response) => {
          this.ajaxPollingData = false;
          this.$emit('speedup');
        })
        .catch((error) => {
          this.ajaxPollingData = false;
          this.$emit('error', error);
        });
    }
  }
}
</script>

<style scoped>

</style>